import axios from "axios"
import { AUTH_STORAGE_KEYS } from "@/shared/config/auth"

/**
 * Axios instance for auth-related requests (login, refresh). Deliberately skips the
 * refresh-retry interceptor from `authenticated-client.ts`: `refresh-token.ts` and the
 * Telegram login call use this client directly, so wiring it through
 * `createAuthenticatedClient` would make a token refresh retry itself on failure.
 */
export const authClient = axios.create({
	baseURL: "/api",
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
})

authClient.interceptors.request.use((config) => {
	const token = sessionStorage.getItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN)
	if (token) {
		config.headers.Authorization = `Bearer ${token}`
	}
	return config
})
